import Navbar from "./components/Navbar";
import {BrowserRouter as Router, Routes,  Navigate, Route} from "react-router-dom";
import Footer from "./components/Footer";

import {useState, useEffect} from "react";
import {v4 as uuidv4} from "uuid";
import {NotificationContext} from "./contexts/NotificationContext";
import Notifications from "./components/Notifications";
import {AuthContext} from "./contexts/AuthContext";
import Login from "./components/Login";
import Spinner from "./components/Spinner";
import Error from "./components/alerts/Error";
import UsersPage from "./components/pages/users";

function App() {
    const [toasts, setToasts] = useState([]);
    const [user, setUser] = useState(null);
    const [useEffectDone, setUseEffectDone] = useState(false);
    const [userLacksRights, setUserLacksRights] = useState(false);

    useEffect(() => {
        (async () => {
            setUseEffectDone(false);
            try {
                const response = await fetchUser();
                if (!response.error && response.user) {
                    setUser(response.user);
                }
            }
            catch (e) {
                console.error(e);
            }
            setUseEffectDone(true);
        })();
    }, []);

    async function fetchUser() {
        const response = await fetch(process.env.REACT_APP_endPoint + '/users/authenticated', {
            method: "GET",
            credentials: "include"
        });

        if (response.status === 403) {
            setUserLacksRights(true);
        }

        return response.json();
    }

    function addToast({message, description}) {
        setToasts((toasts) => {
            return [...toasts, {message,  description, id: uuidv4()}];
        });
    }
    function removeToast(id) {
        setToasts((toasts) => {
            return toasts.filter(value => value.id !== id)
        });
    }

    return (
        <NotificationContext.Provider value={{
            toasts,
            setToasts,
            addToast,
            removeToast
        }}>
            <Notifications />
            <AuthContext.Provider value={{
                user,
                setUser
            }}>
                {useEffectDone ?
                    <>{user ? (<>
                    <Router>
                        <Navbar />
                        <Routes>
                            <Route path={'/users'} element={<UsersPage />}/>
                            <Route path="*" element={<Navigate to="/users" replace />} />
                        </Routes>
                        <Footer />
                    </Router>
                    </>):
                        <Router>
                            <Routes>
                                <Route path={'/signIn'} element={userLacksRights ? <Error message="User doesn't have admin rights" /> : <Login userLacksRights={userLacksRights} />}/>
                                <Route path="*" element={<Navigate to="/signIn" replace />} />
                            </Routes>
                        </Router>
                    }</> :
                    <Spinner />
                }
            </AuthContext.Provider>
        </NotificationContext.Provider>
    );
}


export default App;
